import {
	Directive,
	Input,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewContainerRef,
	ViewRef,
} from '@angular/core';
import { AsyncSubject, BehaviorSubject, of } from 'rxjs';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Features } from 'src/lib/constants/permissions';
import { ActiveStudentService } from 'src/lib/services/startup/active-student/active-student.service';
import { PermissionStoreService } from 'src/lib/services/stores/permission-store/permission-store.service';

@Directive({
	selector: '[aeIfWonderUser]',
})
export class IfWonderUserDirective implements OnInit, OnDestroy {
	private _unsubscribe$ = new AsyncSubject<null>();
	private _userId$ = new BehaviorSubject<number | undefined>(undefined);
	private _viewRef: ViewRef;
	private _isWonderUser: boolean | undefined;
	private _expected = true;

	@Input() public set aeIfWonderUser(expected: boolean) {
		this._expected = expected;
		this.refreshView();
	}

	@Input() public set aeIfWonderUserUserId(userId: number | undefined) {
		this._isWonderUser = undefined;
		this.refreshView();
		this._userId$.next(userId);
	}

	constructor(
		private _viewContainer: ViewContainerRef,
		private _templateRef: TemplateRef<unknown>,
		private _activeStudent: ActiveStudentService,
		private _permissionStore: PermissionStoreService,
	) {}

	ngOnInit(): void {
		this._userId$
			.pipe(
				switchMap((userId) => {
					return userId == null
						? this._activeStudent.getActiveStudent$()
						: of(userId);
				}),
				filter((userId) => userId != null),
				tap(() => {
					this._isWonderUser = undefined;
					this.refreshView();
				}),
				switchMap((userId) =>
					this._permissionStore.getFieldSet$({ UserId: userId }),
				),
				takeUntil(this._unsubscribe$),
			)
			.subscribe((permissions) => {
				this._isWonderUser = permissions.canDo(
					Features['ga_student.wonder_app'],
				);
				this.refreshView();
			});
	}

	ngOnDestroy(): void {
		this._unsubscribe$.next(null);
		this._unsubscribe$.complete();
	}

	private refreshView(): void {
		if (this._isWonderUser === this._expected) {
			if (this._viewRef == null) {
				this._viewRef = this._viewContainer.createEmbeddedView(
					this._templateRef,
				);
			}
		} else if (this._viewRef != null) {
			this._viewContainer.clear();
			this._viewRef = null;
		}
	}
}
